import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem,MessageService } from 'primeng/api';
import saveAs from 'file-saver';
import { Table } from 'primeng/table';
import { first, shareReplay } from 'rxjs';
import { TokenService } from 'src/app/services/common/token.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-full-paymentchallan-details',
  templateUrl: './full-paymentchallan-details.component.html',
  styleUrls: ['./full-paymentchallan-details.component.scss'],
})
export class FullPaymentchallanDetailsComponent implements OnInit {
  @ViewChild('fullPaymentChallanDetailsTable', { static: true })
  public fullPaymentChallanDetailsTable: Table;

  public fullPaymentTableData: any = [];

  acknowledgement = [
    {
      val: 'Yes',
    },
    {
      val: 'No',
    },
  ];

  public displayDialog: boolean = false;
  public selectedAcknowledgement: any;
  public remarks: any = '';
  public vendorRegId: string;
  public userId: any;
  public programId: any;
  public appId: any;
  public vendorCode: any;
  public loading: boolean = false;
  appVerificationItems: MenuItem[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];

  public subscriptions: any = []
  public subjectSub:any;
  public selectedYear:any;

  constructor(
    private messageService: MessageService,
    private vendorService: VendorDashboardService,
    private tokenService: TokenService,
    private translateService: TranslateService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private cryptoJsService: CryptoJsService,
  ) {}

  ngOnInit(): void {
    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.fullPaymentTableData, "Challan_List");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.fullPaymentTableData, "Challan_List");
        }
      },
    ];
    // const token: any = this.tokenService.retrieve();
    // console.log('token', token)
    // this.vendorRegId = JSON.stringify(token?.value?.officeCode);
    // console.log('vendorRegId', this.vendorRegId)

    // let payload = atob(token?.value?.authToken?.split('.')[1]);
    // console.log('payload', JSON.parse(payload))
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));   
     // console.log('token1', token)
    this.vendorRegId = JSON.stringify(token?.officeCode);
    // console.log("officeCode", this.vendorRegId)
    let payload = atob(token?.authToken?.split('.')[1]);
    // console.log('payload1', JSON.parse(payload))

    
    this.userId = JSON.parse(payload)?.sub;
    this.loadDataAndApplyFilter();
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        this.selectedYear = res;
        this.getChallanForVendor(this.userId);
      }
    );
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }

  refreshTable() {
    // this.tankDataTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
    this.getChallanForVendor(this.userId);
  }


  getChallanForVendor(userId) {
    // const token: any = this.tokenService.retrieve();
    // console.log('token', token)
    // this.vendorRegId = JSON.stringify(token?.value?.officeCode);
    // console.log('vendorRegId', this.vendorRegId)

    // let payload = atob(token?.value?.authToken?.split('.')[1]);
    // console.log('payload', JSON.parse(payload))
    // this.loader.start();
    this.loading = true;
    let sub = this.vendorService
      .getChallanForVendor(userId, this.selectedYear)
      // .getChallanForVendor(this.vendorRegId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          // this.activityRecordService.activityRecord(this.userId, 'Full Payment Intimation Details', '', new Date(), 'Success');

          this.fullPaymentTableData = res;
          // this.loader.close();
          this.loading = false;
          // console.log("fullPaymentTableData", this.fullPaymentTableData);
        },
        error: (err) => {
          // this.loader.close();
          this.fullPaymentTableData = [];
          this.loading = false;
          // this.activityRecordService.activityRecord(this.userId, 'Full Payment Intimation Details', '', new Date(), err);

          // console.log("error", err);
          if(err == 'Data not Found!'){
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: err,
            });
          }else{
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: err,
            });
          }
        },
      });

      this.subscriptions.push(sub);
  }


  takeAction(row) {
    this.appId = row.AppId;
    this.programId = row.ProgId;
    this.vendorCode = row.VendorCode;
    this.displayDialog = true;
  }

  onCloseDialog() {
    this.displayDialog = false;
    this.selectedAcknowledgement = null;
    this.remarks = '';
  }

  onSubmitRemark(){
    // console.log('submit clicked')
    let reqBody = {
      appId: this.appId,
      progId: this.programId,
      remarks: this.remarks,
      acknowledgement: this.selectedAcknowledgement.val == "Yes" ? true : false,
      vendorCode: this.vendorCode
    }
    // console.log(reqBody);
    this.insertChallanAcknowledgement(reqBody);
  }


  insertChallanAcknowledgement(reqBody){
     // this.loader.start();
     this.loading = true;
    this.vendorService
      .insertChallanAcknowledgement(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Full Payment Intimation Action', this.appId, new Date(), 'Success');

          // console.log('VendorEstimationUpdatedSuccessfull', data);
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: data,
          });
          this.getChallanForVendor(this.userId);
        },
        error: (error) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Full Payment Intimation Action', this.appId, new Date(), error);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: error,
          });
        },
      });
      this.displayDialog = false;
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "App Id":d.AppId,
          "Credit Date Time":d.CreditDateTime,
          "Transfer Mode":d.TransferMode,
          "Deposit Amount":d.Deposit_Amount,
          "Pending Completed Days":d.PendingCompletedDays,
          "Current Status":d.Status_Ar,
          "Account Number":d.FromAccountNumber,
          "Virtual Account":d.VirtualAccount    
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'AppId', header: 'App Id' },
      { field: 'CreditDateTime', header: 'Credit Date Time' },
      { field: 'TransferMode', header: 'Transfer Mode' },
      { field: 'Deposit_Amount', header: 'Deposit Amount' },
      { field: 'PendingCompletedDays', header: 'Pending Completed Days' },
      { field: 'Status_Ar', header: 'Current Status' },
      { field: 'FromAccountNumber', header: 'Account Number' },
      { field: 'VirtualAccount', header: 'Virtual Account' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  rowBackgroundColor(product){
    if(product.Status_Ar == 'P'){
      if(product.PendingCompletedDays <= -2){
        return '#ff8080';
      }
      else if(product.PendingCompletedDays == -1){
        return '#ffc966';
      }
    }
    else if(product.Status_Ar == 'C' || product.Status_Ar == 'A'){
      if(product.PendingCompletedDays >= -1){
        return '#99e699';
      }
      else if(product.PendingCompletedDays <= -2){
        return '#ffb3b3';
      }
    }
    else
      return '#ffffff';
  }
}
